import { Chart, Plugin } from 'chart.js';
import { basePalette } from '../design-system';

export function updateChartZoomLocations<T extends string>(
  selectedChart: { chart: Chart },
  chartIds: Record<T, string>,
): void {
  const { xScale } = selectedChart.chart.getDatasetMeta(0);
  if (xScale === undefined) {
    return;
  }
  Object.keys(chartIds).forEach((id) => {
    const chartId = chartIds[id as T];
    const chart = Chart.getChart(chartId);
    if (!chart) {
      return;
    }
    if (chart.config.options?.scales?.x && xScale) {
      chart.config.options.scales.x.min = xScale.min;
      chart.config.options.scales.x.max = xScale.max;
      chart.update();
    }
  });
}

export const verticalSelectorLinePlugin: Plugin<'line'> = {
  id: 'verticalSelectorLinePlugin',
  afterDraw: (chart: Chart) => {
    const activeElements = chart.getActiveElements()[0];
    const xValue = activeElements?.element.x;
    const yScale = chart.scales.y;
    if (xValue && yScale) {
      const { ctx } = chart;
      ctx.save();
      ctx.beginPath();
      ctx.moveTo(xValue, yScale.top);
      ctx.lineTo(xValue, yScale.bottom);
      ctx.lineWidth = 1;
      ctx.stroke();
      ctx.restore();
    }
  },
};

const chartColours = [
  '#abcf38',
  '#E9C46A',
  '#889696',
  '#E76F51',
  '#278577',
  '#3E2F5B',
  '#236477',
  '#D7907B',
  '#011627',
  '#4cc9f0',
  '#432818',
  '#f20089',
];

export const colourOptions = [
  basePalette.blue.main,
  basePalette.steel.main,
  basePalette.purple.main,
  basePalette.amber.main,
  basePalette.cyan.main,
  ...chartColours,
];
